<template>
  <div class="relative" @click="productClick()">

    <div class="absolute -top-s5 -left-s5 z-30" v-if="checkForDiscounts()">
      <div class="odd:bg-red even:bg-black rounded-full size-s40 grid place-items-center" v-if="item.first_discount > 0">
        <p class="text-white text-t12">-{{ item.first_discount }}%</p>
      </div>
      <div class="odd:bg-red even:bg-black rounded-full even:-mt-s15 size-s40 grid place-items-center" v-if="item.second_discount > 0">
        <p class="text-white text-t12">-{{ item.second_discount }}%</p>
      </div>
    </div>

    <div class="absolute z-30 text-white -top-s5 -right-s5 w-fit text-center grid gap-s3"
      v-if="item.stickers.length > 0">
      <div v-for="(item, index) in item.stickers" :key="index" class="py-s3 text-t9 uppercase rounded-md w-s100 m_376:w-s120 m_376:text-t10"
        :class="'sticker-' + item.sticker_color">
        {{ item.title }}
      </div>
    </div>

    <a :href="item.path">
      <div class="mx-auto">
        <template v-if="item.hover">
          <vue-slick-carousel :arrows="false" :dots="true" :draggable="false" :lazyLoad="ondemand">
            <div>
              <img :src="item.thumbnail_medium" @error="onImageError" :alt="item.title" class="w-full" width="300" height="455">
            </div>
            <div>
              <img :src="item.hover" :alt="item.title" class="w-full" width="300" height="455">
            </div>
          </vue-slick-carousel>
        </template>
        <template v-else>
          <div>
            <img :src="item.thumbnail_medium" @error="onImageError" :alt="item.title" class="w-full" width="300" height="455">
          </div>
        </template>
      </div>
    </a>

    <div>
      <div class="mt-s15 px-s20 flex justify-between">
        <add-to-wishlist :product-id="item.id" :category="true" :product="item">
        </add-to-wishlist>

        <button type="button" class="border border-black bg-black text-gold p-s3 m_1000:p-0" @click="showQuickView">
          <span class="sr-only">Brzi pregled</span>
          <magnify-icon svgClassName="size-s20 m_426:size-s25"></magnify-icon>
        </button>
      </div>

      <div class="text-center px-s5 pt-s20 relative">
        <p class="font-semibold">{{ item.brend.title }}</p>
        <a :href="item.path">
          <p class="max-h-s15 overflow-hidden m_650:max-h-s20"><a :href="item.path">{{ item.title }}</a></p>
        </a>
        <div class="mt-s10 mx-auto min-h-s45 grid items-end m_426:mt-s20">
          <p v-if="checkForDiscounts()" class="text-dark-gray line-through">{{ formatPrice(item.price_outlet) }} RSD</p>

          <p class="text-t16 font-medium m_376:text-t18 m_650:text-t20"
            :class="checkForDiscounts() ? 'text-red' : 'text-black'">{{ formatPrice(item.finalPrice) }} RSD</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import accounting from 'accounting';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import MagnifyIcon from "../svg/MagnifyIcon.vue";

export default {
  name: "CategoryProduct",
  components: {
    VueSlickCarousel,
    MagnifyIcon
  },
  data() {
    return {
      ondemand: 'ondemand',
    };
  },
  props: [
    'item',
    'index'
  ],

  methods: {
    showQuickView() {
      this.$parent._data.showQuickView = true;
      this.$parent._data.item = this.item;
      this.$nextTick(() => {
        document.querySelector('.quick_view_content').classList.add('active_quick_view');
      });
    },

    formatPrice(value) {
      return accounting.formatMoney(value, '', 2, '.', ',')
    },

    productClick() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'select_item',
        ecommerce: {
          items: [{
            item_name: this.item.title,
            item_id: this.item.movem_id,
            price: this.item.final_price,
            item_brand: this.item.brend.title,
            item_category: this.getCategoriesForFeed(),
            index: this.index,
            quantity: '1'
          }]
        }
      });
    },

    getCategoriesForFeed() {
      if (this.item.categories_for_feed) {
        this.item.categories_for_feed.forEach(function (value, i) {
          'item_category' + (i + 1) + ':' + value;
        })
      } else {
        'item_category:' + this.item.categories[3];
      }
    },

    onImageError(event) {
      // Replace the src with the placeholder if there's an error
      event.target.src = '/images/Movem_1200x1820.png';
    },

    checkForDiscounts() {
      return this.item.first_discount > 0 || this.item.second_discount > 0;
    }

  },
}
</script>

<style scoped>
:deep(.slick-slide){height:auto}:deep(.slick-dots){position:absolute;bottom:10px;width:100%;padding:0;margin:0;list-style:none;text-align:center}:deep(.slick-dots li){position:relative;display:inline-block;margin:0 5px;padding:0}:deep(.slick-dots li button){font-size:0;line-height:0;border-radius:50%;background-color:#000;opacity:.2;padding:5px;color:#fff0}:deep(.slick-dots li.slick-active button){opacity:1}
</style>